import React from 'react';

const NotificationCenterPage: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">알림 센터</h1>
      <p className="text-gray-600">알림 센터 페이지가 여기에 표시됩니다.</p>
    </div>
  );
};

export default NotificationCenterPage;
